import { memo, useState } from 'react'

import Highlighter from 'react-highlight-words'

import { makeStyles, Box, Popover } from '@material-ui/core'

import { Subtitle } from 'UI/Components'

import { DictionaryPotentialItem } from './DictionaryPotentialItem'
import { DictionaryTranscriptForm } from './DictionaryTranscriptForm'

import { useDictionary } from 'hooks'

import { PlaybookApplicationType } from 'app/types'

const useStyles = makeStyles({
    text: {
        fontSize: '12px',
        fontWeight: 500
    }
})

const MIN_SEARCH_LENGTH = 2

const generateWords = (text: string) => {
    return text
        .split(' ')
        .map(it => it.replace(/[.,\s]/g, ''))
        .filter(Boolean)
        .map(it => it + ' ')
}

type Props = {
    text: string
    applications: Array<PlaybookApplicationType>
    transcriptLanguage: string
    showAddToDictionary: boolean
    searchWords: string
    subtitle: Subtitle
}
export const DictionaryWrapper = memo(
    ({
        text,
        applications = [],
        transcriptLanguage,
        showAddToDictionary,
        searchWords,
        subtitle
    }: Props) => {
        const classes = useStyles()
        const { createPhrase } = useDictionary()

        const [anchorEl, setAnchorEl] = useState<Element | null>(null)
        const [phrase, setPhrase] = useState('')

        const onClick = (e: Event, phrase: string) => {
            setAnchorEl(e.currentTarget as Element)
            setPhrase(phrase.trim())
        }

        return (
            <Box>
                {showAddToDictionary ? (
                    <>
                        {generateWords(text).map((word, i) => (
                            <DictionaryPotentialItem key={i + word} onClick={onClick}>
                                {word}
                            </DictionaryPotentialItem>
                        ))}
                    </>
                ) : (
                    <Highlighter
                        highlightStyle={{
                            backgroundColor: '#FFF2C7'
                        }}
                        searchWords={searchWords?.length <= MIN_SEARCH_LENGTH ? [] : [searchWords]}
                        subtitle={subtitle}
                        textToHighlight={text}
                        className={classes.text}
                    />
                )}

                <Popover
                    open={Boolean(anchorEl)}
                    anchorEl={anchorEl}
                    onClose={() => setAnchorEl(null)}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center'
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center'
                    }}
                >
                    <DictionaryTranscriptForm
                        /* @ts-ignore JS FILE */
                        initialPhrase={phrase}
                        createPhrase={createPhrase}
                        applicationsList={applications.map(it => ({
                            name: it.applicationName,
                            value: it.applicationId
                        }))}
                        handleClose={() => setAnchorEl(null)}
                        transcriptLanguage={transcriptLanguage}
                    />
                </Popover>
            </Box>
        )
    }
)
